interface DataTabsStatCardsProps {
  activeItemCount: string | number;
  activeTypeCount: string | number;
  timeframe: string;
  latestDataLabel: string;
  activeTab: string;
  normalizedSymbolQuery: string;
  candleViewsPatternsHits?: number;
}

const CARD_STYLE = {
  background: "rgba(15, 23, 42, 0.62)",
  border: "1px solid rgba(148, 163, 184, 0.16)",
  borderRadius: "14px",
  padding: "0.95rem",
} as const;

const LABEL_STYLE = { color: "var(--color-text-muted)", fontSize: "0.76rem", marginBottom: "0.25rem" } as const;
const VALUE_STYLE = { color: "var(--color-text)", fontSize: "1.25rem", fontWeight: 700 } as const;
const SUB_STYLE = { color: "var(--color-text-muted)", fontSize: "0.76rem", marginTop: "0.22rem" } as const;

export default function DataTabsStatCards({
  activeItemCount,
  activeTypeCount,
  timeframe,
  latestDataLabel,
  activeTab,
  normalizedSymbolQuery,
  candleViewsPatternsHits,
}: DataTabsStatCardsProps) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "0.85rem", marginBottom: "1.5rem" }}>
      <div style={CARD_STYLE}>
        <div style={LABEL_STYLE}>Signal Hits</div>
        <div style={VALUE_STYLE}>
          {activeTab === "patterns" && !normalizedSymbolQuery ? (candleViewsPatternsHits ?? activeItemCount) : activeItemCount}
        </div>
        <div style={SUB_STYLE}>
          {activeTab === "patterns" && !normalizedSymbolQuery ? "Actionable candle setups" : "Matches in the current view"}
        </div>
      </div>

      <div style={CARD_STYLE}>
        <div style={LABEL_STYLE}>Setup Families</div>
        <div style={VALUE_STYLE}>{activeTypeCount}</div>
        <div style={SUB_STYLE}>
          {activeTab === "patterns" && !normalizedSymbolQuery ? "Bullish and bearish setup families" : "Distinct pattern groups"}
        </div>
      </div>

      <div style={CARD_STYLE}>
        <div style={LABEL_STYLE}>Timeframe</div>
        <div style={{ ...VALUE_STYLE, textTransform: "capitalize" }}>{timeframe}</div>
        <div style={SUB_STYLE}>Current scan aggregation</div>
      </div>

      <div style={CARD_STYLE}>
        <div style={LABEL_STYLE}>Latest Scan</div>
        <div style={{ ...VALUE_STYLE, fontSize: "1.02rem" }}>{latestDataLabel}</div>
        <div style={SUB_STYLE}>Most recent candle date</div>
      </div>
    </div>
  );
}
